import { FrozeCloseList } from './FrozeCloseList/FrozeCloseList'
import { OrderLineList } from './OrderLineList'
import { MilletBlock } from './MilletBlock/MilletBlock'
import {
  IPlanMenuCloseOrderDetailDto,
  IPlanMenuCloseOrdersRequest,
} from 'core/api/dto/PlanMenuCloseDto'

export interface IMainBlockProps {
  orderDetail?: IPlanMenuCloseOrderDetailDto | undefined
  orderId: string | null
  onClick?: () => void
  pageParams: IPlanMenuCloseOrdersRequest | null
  width: number
  setIsShowPopup: () => void
  setIsShowOnePopup: () => void
  dimensionId: string | null
  dishId: string | null
}

export const MainBlock = ({
  onClick,
  width,
  orderId,
  orderDetail,
  pageParams,
  setIsShowPopup,
  setIsShowOnePopup,
  dimensionId,
  dishId,
}: IMainBlockProps) => {
  return (
    <div className="row">
      <div
        className={`width-${width <= 1024 ? (width <= 768 ? 100 : 33) : 33}`}
      >
        {orderDetail && orderId && (
          <OrderLineList
            pageParams={pageParams}
            setIsShowPopup={setIsShowPopup}
          />
        )}
      </div>

      <div
        className={`width-${width <= 1024 ? (width <= 768 ? 100 : 33) : 33}`}
      >
        {orderDetail && orderId && dishId && (
          <FrozeCloseList
            pageParams={{
              ...pageParams,
            }}
            withTaskAddButton={false}
          />
        )}
      </div>
      <div
        className={`width-${width <= 1024 ? (width <= 768 ? 100 : 33) : 33}`}
      >
        {orderDetail && orderId && dimensionId && (
          <>
            <MilletBlock
              pageParams={{
                ...pageParams,
              }}
              onClick={setIsShowOnePopup}
            />
          </>
        )}
      </div>
    </div>
  )
}
